import React, { Component } from 'react';
import { PopUpCloseBtn, PopUpHeader, PopUpTitle, SeparatorLine, TransparencyPopUp } from '../../CapaLlegendaFooterElements';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';
import { styled } from '@mui/material/styles';
import Slider from '@mui/material/Slider';

const CustomSlider = styled(Slider)({
  color: '#fff',
  margin: 0,
  padding: 0,
  height: 6,
  '& .MuiSlider-track': {
    border: 'none'
  },
  '& .MuiSlider-thumb': {
    height: 17,
    width: 17,
    backgroundColor: '#febf00',
    border: '0px solid #febf00',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit'
    },
    '&:before': {
      display: 'none'
    }
  }
});

export default class Transparency extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  /**
   *
   * @desc Función para obtener el valor del slider de transparencia cada vez que cambia
   */
  handleSliderTransparencyChange = (event, value) => {
    this.props.layer.getOLLayer().setOpacity(value / 100);
    this.forceUpdate();
  };

  render() {
    return (
      <>
        <SeparatorLine />
        <PopUpHeader>
          <PopUpTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('titleTransparency')}</PopUpTitle>
          <PopUpCloseBtn title={getTranslatedKey('tancar')} onClick={() => this.props.handleClosePopUp()}>
            <svg
              width={this.props.fontSizeEnabled ? 24 * 1.3 : 24}
              fill="white"
              transform="rotate(180)"
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="ExpandMoreIcon">
              <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
            </svg>
          </PopUpCloseBtn>
        </PopUpHeader>
        <TransparencyPopUp id="notSortable">
          <CustomSlider
            valueLabelDisplay="auto"
            defaultValue={this.props.layer.getOLLayer().getOpacity() * 100}
            value={Math.round(this.props.layer.getOLLayer().getOpacity() * 100)}
            onChange={this.handleSliderTransparencyChange}
          />
        </TransparencyPopUp>
      </>
    );
  }
}
